export let roundWithTwoDecimals = number => {
    return Math.round(number * 100) / 100
};